export default '2.2.1';



// WEBPACK FOOTER //
// ./src/lib/version.js